<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("Proof of funds") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="topFilter">
      <div class="container lg">
        <div class="form-group">
          <label for="filter" class="sr-only">Filter</label>
          <input
            type="text"
            class="form-control filter"
            v-model="filter"
            placeholder="Search..."
          />
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn" v-if="ready">
      <div v-if="history_rows.length != 0">
        <datatable
          :columns="history_columns"
          :data="history_rows"
          :filter-by="filter"
          class=""
        >
          <template slot-scope="{ row }">
            <tr>
              <td colspan="2">
                <span class="font-bold">
                  <router-link v-bind:to="'/user/' + row.user_id">
                    ...{{ row.user_id.slice(-5) }}
                  </router-link></span
                >
              </td>
              <td colspan="3" class="text-right">
                <span class="font-bold"
                  >{{ row.amount.toFixed(7) / 1 }} {{ currency }}</span
                >
              </td>
            </tr>
          </template>
        </datatable>
        <div class="pager-footer">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
            class="text-center"
          ></datatable-pager>
        </div>
      </div>
      <div v-else>
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>You have no data.</h4>
        </div>
      </div>
    </div>
    <div class="container-center lg loader-example" v-else>
      <div class="loader-bar"></div>
    </div>
  </div>
</template>
<script>
import info from "@/api/info";
import func from "@/widgets/func";
import { mapGetters } from "vuex";
import nativeToast from "native-toast";

export default {
  data() {
    return {
      currency: this.$route.params.currency,
      ready: false,
      loading: false,
      filter: "",
      history_columns: [
        {
          label: "",
          field: "user_id",
          sortable: false,
        },
        {
          label: "",
          field: "amount",
          sortable: false,
        },
      ],
      history_rows: [],
      page: 1,
      per_page: 20,
    };
  },
  computed: mapGetters(["getUser"]),
  methods: {
    fixed(a) {
      return func.fixed8(a);
    },
    getdata() {
      this.commission = [];
      info
        .funds(this.$route.params.currency)
        .then((res) => {
          this.history_rows = [];
          res.data.forEach((e) => {
            this.history_rows.push(e);
          });
          this.ready = true;
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
  },
  created() {
    this.getdata();
  },
};
</script>

<style scoped>
.container-center {
  margin-top: 20px;
  padding-top: 40px;
}
.coin img {
  margin-left: 20px;
}
.coin {
  color: white;
  font-size: 20px;
}
.progress-small,
.progress-small .progress-bar {
  height: 30px;
}
.progress {
  border-radius: 20px;
  margin-bottom: 0px;
  background-color: transparent;
  background-image: linear-gradient(0deg, #192330, #414011 50%, #192330);
  height: 30px;
  position: relative;
}
.full .progress-bar-warning {
  background-image: linear-gradient(180deg, #ffe170, #ffb900);
  height: 22px;
  border-radius: 22px;
  position: absolute;
  top: 4px;
  left: 0px;
}
.full .progress-bar-warning {
  border-right: 0px solid #fff;
}
.progress-bar {
  padding-right: 0px;
}
.text-admin {
  color: #32353c;
}

.text-gold {
  color: rgba(255, 223, 0, 1);
}
.text-silver {
  color: hsla(0, 0%, 75.3%, 1);
}
.text-bronze {
  color: rgba(205, 127, 50, 1);
}
</style>
